
export const formatSerialList = serialArray => serialArray.toString();

export const formatTime = (epochTime) => {
  const date = new Date(0);
  date.setUTCSeconds(epochTime);
  return `${date.toLocaleString()}`;
};



// WEBPACK FOOTER //
// ./src/helpers/formatHelpers.js